import styled from "styled-components";

interface Props {
  children: React.ReactNode;
  className?: string;
}

export const SmartphonePreview: React.FC<Props> = ({ children, className }) => {
  return (
    <Phone className={`smartphone_preview ${className}`}>
      <Notch className="smartphone_preview-notch">
        <NotchSpeaker />
      </Notch>

      <Screen className="smartphone_preview-screen">
        <StatusBar className="smartphone_preview-statusbar">
          <StatusTime>{new Date().toLocaleString(undefined, { hour: "2-digit", minute: "2-digit" })}</StatusTime>
          <StatusIcons>
            <svg style={{ width: "16px", height: "16px" }} fill="currentColor" viewBox="0 0 20 20">
              <path d="M2 11a1 1 0 011-1h2a1 1 0 011 1v5a1 1 0 01-1 1H3a1 1 0 01-1-1v-5zM8 7a1 1 0 011-1h2a1 1 0 011 1v9a1 1 0 01-1 1H9a1 1 0 01-1-1V7zM14 4a1 1 0 011-1h2a1 1 0 011 1v12a1 1 0 01-1 1h-2a1 1 0 01-1-1V4z" />
            </svg>
            <svg style={{ width: "12px", height: "12px" }} fill="currentColor" viewBox="0 0 20 20">
              <path
                fillRule="evenodd"
                d="M17.778 8.222c-4.296-4.296-11.26-4.296-15.556 0A1 1 0 01.808 6.808c5.076-5.077 13.308-5.077 18.384 0a1 1 0 01-1.414 1.414zM14.95 11.05a7 7 0 00-9.9 0 1 1 0 01-1.414-1.414 9 9 0 0112.728 0 1 1 0 01-1.414 1.414zM12.12 13.88a3 3 0 00-4.242 0 1 1 0 01-1.415-1.415 5 5 0 017.072 0 1 1 0 01-1.415 1.415zM9 16a1 1 0 011-1h.01a1 1 0 110 2H10a1 1 0 01-1-1z"
                clipRule="evenodd"
              />
            </svg>
            {/* The dream */}
            <Battery>100%</Battery>
          </StatusIcons>
        </StatusBar>
        <Content className="smartphone_preview-content">{children}</Content>
      </Screen>

      <HomeIndicator className="smartphone_preview-home_indicator" />
    </Phone>
  );
};

const Phone = styled.div`
  box-sizing: border-box;
  position: relative;
  width: 100%;
  max-width: 100%;
  height: 680px;
  background-color: #111827;
  border-radius: 50px;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  padding: 12px;

  ${({ theme }) => theme.aboveBreakpoint} {
    max-width: 340px;
  }
`;

const Notch = styled.div`
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 160px;
  height: 28px;
  background-color: #000000;
  border-bottom-left-radius: 24px;
  border-bottom-right-radius: 24px;
  z-index: 10;
`;

const NotchSpeaker = styled.div`
  position: absolute;
  top: 8px;
  left: 50%;
  transform: translateX(-50%);
  width: 64px;
  height: 4px;
  background-color: #1f2937;
  border-radius: 9999px;
`;

const Screen = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  border-radius: 42px;
  overflow: auto;
`;

const StatusBar = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 48px;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0.05), transparent);
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 32px 0 32px;
`;

const StatusTime = styled.span`
  font-size: 12px;
  font-weight: 600;
`;

const StatusIcons = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

const Battery = styled.div`
  font-size: 12px;
  font-weight: 600;
`;

const Content = styled.div`
  width: 100%;
  padding: 56px 0 24px;
  overflow-y: auto;
`;

const HomeIndicator = styled.div`
  position: absolute;
  bottom: 8px;
  left: 50%;
  transform: translateX(-50%);
  width: 128px;
  height: 4px;
  background-color: #111827;
  border-radius: 9999px;
`;
